import type { SVGProps } from 'react';

const SvgArrowLeftDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={20}
    viewBox='0 0 20 20'
    width={20}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M9.442 5.442a.625.625 0 1 0-.884-.884l-5 5a.625.625 0 0 0 0 .884l5 5a.625.625 0 1 0 .884-.884L4.884 10zm7 0a.625.625 0 1 0-.884-.884l-5 5a.625.625 0 0 0 0 .884l5 5a.625.625 0 1 0 .884-.884L11.884 10z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgArrowLeftDouble;
